import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    parseStatus,
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const messageTipOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: true,
    expandRowKeys: [],
    rowKey: 'id',
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '220',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "用户姓名",
            prop: "name",
            type: 'input',
            search: true
        },
        {
            label: "用户电话",
            prop: "mobile",
            type: 'input',
            search: true

        },
        {
            label: "提醒参数内容",
            prop: "parameterName",
            type: 'input',
            search: true

        },
        {
            label: "服务时间",
            prop: "serviceTime",
            type: "datetime",
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // sortable: true,
            // formatter: function (row, value, label, column) {
            //     let time = row.time + parseStatus(DIC.SERVICE_WARRANTY_DATE_TYPE, row.type)
            //     return time
            // },
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "提醒时间",
            prop: "remindTime",
            type: "datetime",
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // sortable: true,
            formatter: function (row, value, label, column) {
                // let time = row.time + parseStatus(DIC.SERVICE_WARRANTY_DATE_TYPE, row.type)
                return row.vices[0].remindTime
            },
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "服务时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        },
        {
            label: "提醒时间",
            prop: "startDate_endDate1",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
        // {
        //     label: "总服务费",
        //     prop: "totalMoney",
        //     type: 'input',
        //     formatter: function (row, value, label, column) {
        //         if (row.totalMoney == 0) {
        //             return '-'
        //         } else {
        //             return row.totalMoney
        //         }
        //     }
        // },
        // {
        //     label: "预约渠道",
        //     prop: "reservationChannel",
        //     type: 'input',
        //     dicData: DIC.SERVICEITEM_TYPE
        // },
        // {
        //     label: "工程单状态",
        //     prop: "status",
        //     type: 'input',
        //     dicData: DIC.WORK_ORDER_STATUS
        // },
        // {
        //     label: "创建人",
        //     prop: "createBy",
        //     type: 'input',
        // },
        // {
        //     label: "创建时间",
        //     prop: "createTime",
        //     type: "datetime",
        //     // sortable: true,
        //     valueFormat: "timestamp",
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
    ]
};